import * as yup from 'yup'

export const dashboardSchema = yup.object().shape({
  name: yup.string().required().max(100, 'Max 100'),
  widgetRows: yup.bool().oneOf([true], 'Please select a widget'),
})
